import React, { useState } from 'react'
import { Box, Button, IconButton } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';

function ModalRemoveAllNames({ onClose, onSubmit }) {
    return (
        <>
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>นำออกทั้งหมด</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px', margin: '10px 0' }}>
                        <Box>ยืนยันการล้างรายชื่อออกจากรายชื่อที่เลือกไว้หรือไม่ ?</Box>
                        <Box>การล้างรายชื่อนี้จะไม่ส่งผลต่อรายชื่อที่ถูกเพิ่มในโครงการไปแล้ว</Box>
                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                variant='contained'
                                sx={{ backgroundColor: '#E06262' }}
                                onClick={() => { 
                                    onSubmit()
                                    onClose()
                                }}
                            >นำออกทั้งหมด</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalRemoveAllNames
